import React from 'react';
import { Box, Grid, Typography } from '@material-ui/core';
import { useLocale } from 'hooks';
import { useFormContext } from 'react-hook-form';

import { StepContainer } from '../stepContainer/StepContainer';
import { Button, InfoBlock } from 'ui';
import { BlockIcon, LikeIcon, RecycleFeeIcon } from 'ui/icons';

import { StepAssetFormProps } from './StepFormFeeManufacturer.types';
import { useStyles } from './StepFormFeeManufacturer.styles';

export const StepFormFeeManufacturer = ({ goToNextStep, goToPreviousStep, onSubmit }: StepAssetFormProps) => {
  const { formatMessage } = useLocale();
  const { watch, setValue } = useFormContext();
  const classes = useStyles();
  const watchWeight = watch('weight', 0);
  const cost = watch('cost', 1.23) || 1.23;

  const handleContinue = () => {
    setValue('fee', watchWeight * cost);
    onSubmit();
    goToNextStep();
  };

  return (
    <StepContainer title={formatMessage({ id: `issue_battery.form.fee_title` })}>
      <Grid container className={classes.feeContainer} direction="row" justify="space-between">
        <div className={classes.infoBlockContainer}>
          <InfoBlock
            items={[
              {
                text: `${cost} EUR`,
                textIcon: BlockIcon,
                label: formatMessage({ id: 'issue_battery.form.fee_price_per_kg' }),
              },
            ]}
          />
        </div>
        <div className={classes.infoBlockContainer}>
          <InfoBlock
            items={[
              {
                text: `${watchWeight} kg`,
                textIcon: LikeIcon,
                label: formatMessage({ id: 'issue_battery.form.fee_battery_weight' }),
              },
            ]}
          />
        </div>
      </Grid>
      <Grid container direction="column" justify="center" alignItems="center" className={classes.container}>
        <Box>
          <RecycleFeeIcon className={classes.recycleIcon} />
        </Box>
        <Box className={classes.fee}>
          <Typography className={classes.feeTitle}>{formatMessage({ id: 'issue_battery.form.fee' })}</Typography>
          <Typography className={classes.feeValue}>
            {formatMessage({ id: 'issue_battery.form.fee_value' }, { value: (cost * watchWeight).toFixed(2) })}
          </Typography>
        </Box>
        <Grid container className={classes.actions} spacing={2}>
          <Grid item xs={6}>
            <Button variant="outlined" color="primary" onClick={goToPreviousStep}>
              {formatMessage({ id: 'common.back' })}
            </Button>
          </Grid>
          <Grid item xs={6}>
            <Button variant="contained" color="primary" onClick={handleContinue}>
              {formatMessage({ id: 'issue_battery.form.deposit_founds' })}
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </StepContainer>
  );
};
